import { Div, Img } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { APP_VERSION } from '../../configs/app'
import { toFaDigits } from '../../helpers/digits'
import style from './index.module.css'

// About page: app icon, name, version, a short description, and a credit line.
export const AboutPage = () => {
    const base = SheetPage('دربارهٔ امروز')

    const hero = Div()
    hero.addClass(style.hero)
    const icon = Img('/images/icon-192.png')
    icon.addClass(style.icon)
    const version = Div(`نسخهٔ ${toFaDigits(APP_VERSION)}`)
    version.addClass(style.version)
    hero.append(icon, version)
    base.append(hero)

    const desc = Div(
        'امروز یک تقویم فارسی (جلالی) است که تاریخ میلادی و قمری را هم‌زمان کنار هم نشان می‌دهد ' +
        'و رویدادهای رسمی ایران را در خود دارد. بدون نیاز به حساب کاربری کار می‌کند، و تقویم و رویدادهای ایران به اینترنت نیازی ندارند.'
    )
    desc.addClass(style.desc)
    base.append(desc)

    // The word vectors search uses are CC BY-SA, which asks for their source
    // and licence to be named wherever they are shipped. The citation is a
    // line of its own, left to right: brackets round Latin text inside a
    // Persian sentence come apart when the line wraps.
    const vectors = Div('جستجو برای پیدا کردن واژه‌های هم‌معنا از بردارهای واژهٔ fastText استفاده می‌کند:')
    vectors.addClass(style.notice)
    const source = Div('Grave et al. 2018, CC BY-SA 3.0')
    source.attr('dir', 'ltr')
    source.addClass(style.source)
    vectors.append(source)
    base.append(vectors)

    const credit = Div('ساخته‌شده با ♥ در کدسوما')
    credit.addClass(style.credit)
    base.append(credit)

    return base
}
